import { React, useEffect, useState } from 'react'
import Header from './Comman/Header'
import axios from "axios";


export default function Profile() {
    const username = localStorage.getItem("username");
    const [data, setdata] = useState({});

    const getData = async () => {
        if (!username) return;
        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "user",
                submethod: "profile",
                username: username,
                key: process.env.REACT_APP_KEY,
            });
            if (!res.data.error) setdata(res.data.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        getData();
    }, [username]);

    const givenDate = new Date(data?.date);
    const today = new Date();
    const diffTime = today - givenDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    const totalEarning = (
        Number(data?.rank_rew || 0) +
        Number(data?.level_rew || 0) +
        Number(data?.ror_rew || 0) +
        Number(data?.week_rew || 0)
    ).toFixed(2);


    const customStyles = `
    .db-profile-card {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.05);
        border-radius: 20px;
        overflow: hidden;
        position: relative;
        box-shadow: 0 10px 40px rgba(0,0,0,0.03);
    }
    
    .ai-banner {
        height: 200px;
        background: linear-gradient(135deg, #006fe3 0%, #005bb5 100%);
        position: relative;
    }
    .ai-banner::after {
        content: '';
        position: absolute;
        top: 0; left: 0; width: 100%; height: 100%;
        background-image: url('assets/img/getlink_dashboard_hero_image_01.jpg');
        background-size: cover;
        background-position: center;
        opacity: 0.2;
        mix-blend-mode: overlay;
    }

    .ai-avatar-container {
        position: relative;
        margin-top: -75px;
        margin-left: 40px;
        width: 150px;
        height: 150px;
    }
    
    .ai-avatar {
        width: 100%; height: 100%;
        border-radius: 50%;
        border: 6px solid #ffffff;
        object-fit: cover;
        background: #fff;
        box-shadow: 0 10px 25px rgba(0,0,0,0.1);
    }
    
    .ai-status-dot {
        position: absolute;
        bottom: 15px; right: 15px;
        width: 20px; height: 20px;
        background: #10b981;
        border: 3px solid #ffffff;
        border-radius: 50%;
        box-shadow: 0 0 10px rgba(16, 185, 129, 0.4);
    }

    .ai-user-info {
        padding: 20px 40px 40px; 
    }
    
    .ai-username {
        font-size: 32px;
        font-weight: 800;
        color: #1a2234;
        margin-bottom: 5px;
    }

    /* STATS GRID */
    .ai-stats-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 20px;
        margin-top: 40px;
    }
    
    .ai-stat-box {
        background: rgba(238, 242, 246, 0.5); 
        border: 1px solid rgba(255, 255, 255, 0.8);
        border-radius: 16px;
        padding: 24px;
        text-align: center;
        position: relative;
        overflow: hidden;
        transition: transform 0.3s;
        box-shadow: 1px 15px 15px 0px rgba(191, 201, 216, 0.2), inset 0 1px 0 #ffffff;
    }
    .ai-stat-box:hover {
        transform: translateY(-5px);
        border-color: #006fe3;
    }
    
    .ai-stat-value {
        font-size: 28px;
        font-weight: 800;
        color: #1a2234;
        margin-bottom: 5px;
    }
    .ai-stat-label {
        color: #64748b;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 1px;
        text-transform: uppercase;
    }
    
    .ai-stat-icon {
        position: absolute;
        top: -10px; right: -10px;
        font-size: 80px;
        opacity: 0.1;
        color: #006fe3;
    }

    /* ACTION BUTTONS */
    .ai-actions {
        display: flex; gap: 15px;
        margin-top: 30px;
        flex-wrap: wrap;
    }
    
    .ai-btn-secondary {
        background: #f8fafc;
        color: #1e293b;
        border: 1px solid #e2e8f0;
        padding: 12px 24px;
        border-radius: 10px;
        font-weight: 700;
        transition: 0.2s;
        text-decoration: none;
        display: inline-flex; align-items: center; gap: 8px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.02);
    }
    .ai-btn-secondary:hover {
        background: #e2e8f0;
        color: #0f172a;
    }
    
    .ai-btn-primary {
         background: linear-gradient(135deg, #006fe3, #005bb5);
         color: #fff;
         border: none;
         padding: 12px 24px;
         border-radius: 10px;
         font-weight: 700;
         text-decoration: none;
         display: inline-flex; align-items: center; gap: 8px;
         box-shadow: 0 4px 12px rgba(0, 111, 227, 0.3);
         transition: 0.2s;
    }
    .ai-btn-primary:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 16px rgba(0, 111, 227, 0.4);
        color: #fff;
    }
    
    @media (max-width: 768px) {
        .ai-banner { height: 140px; }
        .ai-avatar-container { margin-left: 20px; width: 100px; height: 100px; margin-top: -50px; }
        .ai-user-info { padding: 20px; }
        .ai-username { font-size: 24px; }
    }
    `;

    return (
        <>
            <style>{customStyles}</style>
            <div className="body-bg">
                {/* Sidebar handled by Layout if present, else just Header */}
                <Header />
                <section className="nftmax-adashboard nftmax-show mt-4">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-9 col-12">

                                <div className="db-profile-card mb-5">

                                    {/* Banner */}
                                    <div className="ai-banner"></div>

                                    {/* User Info & Stats */}
                                    <div className="ai-user-info">
                                        <div className="d-flex flex-wrap align-items-end justify-content-between">
                                            <div>
                                                <div className="ai-avatar-container">
                                                    <img src="darklogo-192.png" className="ai-avatar pe-2" alt="Profile" />
                                                    <div className="ai-status-dot"></div>
                                                </div>
                                                <div className="mt-3">
                                                    <h2 className="ai-username fs-5">User Name : {username || "User"}</h2>
                                                    {/* <div className="d-flex gap-2">
                                                        <span className="ai-badge">Level 1</span>
                                                        <span className="ai-badge" style={{ borderColor: 'rgba(16, 185, 129, 0.3)', color: '#34d399', background: 'rgba(16, 185, 129, 0.15)' }}>Active</span>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className="ai-actions">

                                                {data?.email && (
                                                    <a href="/updateName" className="ai-btn-secondary">
                                                        <i className="fa fa-user"></i> Update Name
                                                    </a>
                                                )}
                                                {/* Placeholder for future edit */}
                                                {/* <a href="#" className="ai-btn-secondary"><i className="fa fa-edit"></i> Edit</a> */}
                                            </div>
                                            <div className="ai-actions">
                                                {!data?.email && (
                                                    <a href="/verifyEmail" className="ai-btn-primary">
                                                        <i className="fa fa-envelope"></i> Verify Email
                                                    </a>
                                                )}
                                                {data?.email && (
                                                    <a href="/changepassword" className="ai-btn-secondary">
                                                        <i className="fa fa-key"></i> Update Password
                                                    </a>
                                                )}
                                                {/* Placeholder for future edit */}
                                                {/* <a href="#" className="ai-btn-secondary"><i className="fa fa-edit"></i> Edit</a> */}
                                            </div>
                                        </div>

                                        {/* Stats Grid */}
                                        <div className="ai-stats-grid">

                                            <div className="ai-stat-box">
                                                <i className="fa fa-layer-group ai-stat-icon"></i>
                                                <div className="ai-stat-value">${data?.total_staking ? Number(data?.total_staking).toFixed(2) : "0.00"}</div>
                                                <div className="ai-stat-label">Total Staking</div>
                                            </div>

                                            <div className="ai-stat-box">
                                                <i className="fa fa-coins ai-stat-icon"></i>
                                                <div className="ai-stat-value" style={{ color: '#10b981' }}>${totalEarning}</div>
                                                <div className="ai-stat-label">Total Earnings</div>
                                            </div>

                                            <div className="ai-stat-box">
                                                <i className="fa fa-clock ai-stat-icon"></i>
                                                <div className="ai-stat-value">{diffDays || 0}</div>
                                                <div className="ai-stat-label">Days Active</div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
